import React from "react";
import "./pages.css";
import PhotoLife from "../components/photographyLifestyleLoop";

function Lifestyle({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Photography | Taps</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main>
          <PhotoLife deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default Lifestyle;
